<template>
  <v-avatar class="profile-avatar mb-3" :size="width">
    <slim-cropper :options="slimOptions" :style="'width: ' + width + 'px; height: ' + height + 'px;'">
      <input type="file" accept="image/jpeg,image/png,image/gif,image/webp" />

      <img v-if="initialPicture" :src="initialPicture" alt="Gruppenbild" />
    </slim-cropper>
  </v-avatar>
</template>

<script>
// Importiert dein Slim Cropper Plugin
import Slim from "@/plugins/slimImage/slim/slim.vue"
// Importiert deine zentrale API-Datei
import api from "@/api"

export default {
  name: "ChatGroupPicture",
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    /**
     * Die _id der Chat-Gruppe, die bearbeitet wird.
     */
    groupId: {
      type: String,
      required: true,
    },
    /**
     * Das *aktuelle* Bild der Gruppe (z.B. '/uploads/bild.webp')
     */
    initialPicture: {
      type: String,
      default: null,
    },
    width: {
      type: Number,
      default: 125,
    },
    height: {
      type: Number,
      default: 125,
    },
  },
  components: { "slim-cropper": Slim },
  methods: {
    /**
     * Diese Methode wird vom Slim Cropper als 'service' aufgerufen.
     */
    uploadPicture(formdata, progress, success, failure, slim) {
      if (!this.isAdmin) {
        this.$toast.error("Nur Admins können das Gruppenbild ändern.")
        return
      }
      const formData = new FormData()
      formData.append("file", formdata[0])

      let uploadimg = {}
      uploadimg.art = "chat_group_bild"
      uploadimg.groupId = this.groupId

      uploadimg.formData = formData
      api
        .uploadImage(uploadimg)
        .then((data) => {
          if (data.status) {
            // Sende den NEUEN Bild-Pfad an die Eltern-Komponente
            this.$emit("updatedPicture", data.name)
            success(data)
          } else {
            // Falls Backend Fehler sendet
            failure("Upload fehlgeschlagen")
          }
        })
        .catch((error) => {
          failure("Netzwerkfehler")
          console.log(error)
        })
    },
  },
  computed: {
    /**
     * Konfiguration für den Slim Cropper
     */
    slimOptions() {
      return {
        ratio: "1:1", // Quadratisch
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        "data-button-remove-label": false,
        label: "Bild ändern", // "Bild hochladen" -> "Bild ändern" passt oft besser
        "data-edit": false,
        buttonUpload: true,
        dataRemove: false,
        labelLoading: "Wird hochgeladen...",
        statusUploadSuccess: "Gespeichert",
        service: this.uploadPicture,
        serviceFormat: "file", // Sendet das File-Objekt (behält Format bei)
        instantEdit: true,
        push: true,
        // WICHTIG: Fallback Bild, falls kein InitialPicture da ist
        initialImage: this.initialPicture || "/img/einmalig/imageUploadPlaceholderPFP.jpg",
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* Optional: Schatten für den Avatar */
.profile-avatar {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}
</style>
